export default __webpack_public_path__ + "static/media/erricons.89f92599.svg";